export default __webpack_public_path__ + "static/media/ci.bee3cccb.svg";